import { PlayerSessionShared } from "@shared/types";
import { getPlayerSessionId } from "../../helpers";

async function sendGetPlayerSessionRequest(): Promise<PlayerSessionShared | null> {
    try {
        const response: Response = await fetch(`${viteConfiguration.API_URL}player/status/get`, {
            method: "get",
            headers: {
                "Content-Type": "application/json",
                "X-PlayerSessionId": getPlayerSessionId(),
            },
        });

        const result: any = await response.json();

        if (!result) {
            return null;
        }

        return result.data;
    } catch (error) {
        console.error(error);
    }
    return null;
}

export default sendGetPlayerSessionRequest;
